<template>
  <div class="mapboxgl-ctrl mapboxgl-ctrl-group" v-show="showVisitorFlow">
    <button
      @click="$store.dispatch('sightmapevent/inqueueMapEvent', {
        event: 'handleShowVisitorFlow'
      })"
      class="mapboxgl-ctrl-icon"
      aria-label="Visitor Flow"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" :fill="mapVisitorFlowMode ? 'black' : 'white'" />
        <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" :stroke="mapVisitorFlowMode ? '#11FF00' : 'rgba(0, 0, 0, 0.1)'" />
        <path d="M9.9999 4.40002C10.7721 4.40002 11.3999 5.02784 11.3999 5.80002C11.3999 6.57221 10.7721 7.20002 9.9999 7.20002C9.22772 7.20002 8.5999 6.57221 8.5999 5.80002C8.5999 5.02784 9.22772 4.40002 9.9999 4.40002ZM12.0999 11.225C12.0999 11.7719 11.8221 12.2531 11.3999 12.5353V14.55C11.3999 15.1297 10.9296 15.6 10.3499 15.6H9.6499C9.07021 15.6 8.5999 15.1297 8.5999 14.55V12.5353C8.17771 12.2531 7.8999 11.7719 7.8999 11.225V10.35C7.8999 9.19065 8.84053 8.25002 9.9999 8.25002C11.1593 8.25002 12.0999 9.19065 12.0999 10.35V11.225ZM6.4999 5.10002C7.17584 5.10002 7.7249 5.64909 7.7249 6.32502C7.7249 7.00096 7.17584 7.55002 6.4999 7.55002C5.82396 7.55002 5.2749 7.00096 5.2749 6.32502C5.2749 5.64909 5.82396 5.10002 6.4999 5.10002ZM6.8499 10.35V11.05C6.8499 11.761 7.11459 12.4085 7.5499 12.9028V14.55C7.5499 14.5763 7.5499 14.6047 7.55209 14.631C7.36615 14.7972 7.12115 14.9 6.8499 14.9H6.1499C5.57021 14.9 5.0999 14.4297 5.0999 13.85V12.6119C4.68209 12.3713 4.3999 11.9185 4.3999 11.4V10.7C4.3999 9.54065 5.34053 8.60002 6.4999 8.60002C6.77771 8.60002 7.0424 8.65471 7.28521 8.75096C7.00959 9.21909 6.8499 9.76596 6.8499 10.35ZM12.4499 14.55V12.9028C12.8852 12.4106 13.1499 11.761 13.1499 11.05V10.35C13.1499 9.76596 12.9902 9.22127 12.7146 8.75096C12.9574 8.65252 13.2221 8.60002 13.4999 8.60002C14.6593 8.60002 15.5999 9.54065 15.5999 10.7V11.4C15.5999 11.9185 15.3177 12.3713 14.8999 12.6119V13.85C14.8999 14.4297 14.4296 14.9 13.8499 14.9H13.1499C12.8808 14.9 12.6337 14.7994 12.4477 14.631C12.4477 14.6047 12.4499 14.5763 12.4499 14.55ZM13.4999 5.10002C14.1758 5.10002 14.7249 5.64909 14.7249 6.32502C14.7249 7.00096 14.1758 7.55002 13.4999 7.55002C12.824 7.55002 12.2749 7.00096 12.2749 6.32502C12.2749 5.64909 12.824 5.10002 13.4999 5.10002Z" :fill="mapVisitorFlowMode ? '#11FF00' : 'black'" />
      </svg>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'sight-map-visitor-flow-btn',
  uit() {
    return [
      // ['action', ['filter']]
    ]
  },
  computed: {
    ...mapState({
      mapVisitorFlowMode: state => state.ui.mapVisitorFlowMode,
      showVisitorFlow: state => state.geolocation.showVisitorFlow
    })
  }
}
</script>

<style>
.mapboxgl-ctrl-visitor-flow-toggle .mapboxgl-ctrl.mapboxgl-ctrl-group {
  border: none;
  box-shadow: none;
  background: transparent;
}
.mapboxgl-ctrl-visitor-flow-toggle .mapboxgl-ctrl.mapboxgl-ctrl-group {
  transform: scale(1.1);
}
.mapboxgl-ctrl-visitor-flow-toggle .mapboxgl-ctrl.mapboxgl-ctrl-group button > svg {
  width: 100%;
  height: 100%;
}
</style>
